import { styled as StyledMui } from "@mui/system";
import { Box } from "@mui/material";

export const MainContainer = StyledMui(Box)(
  ({ margintop, calcheight, isHeaderShrink }) => ({
    width: "inherit",
    margin: margintop === "true" ? "8.5rem 0 0" : "0",
  })
);

export const ScrollableContainer = StyledMui(Box)(() => ({
  maxWidth: "1800px",
  width: "100%",
  padding: "0 0 2rem 0",
  margin: "0 auto 0",
  display: "grid",
  gridGap: "2rem",
  gridTemplateColumns: "repeat(4,1fr)",
  overflowY: "scroll",
  "@media only screen and (min-width: 950px) and (max-width: 1720px)": {
    gridTemplateColumns: "repeat(3,1fr)",
  },
  "@media only screen and (min-width: 650px) and (max-width: 950px)": {
    gridTemplateColumns: "repeat(2,1fr)",
  },
  "@media only screen and (max-width: 649px)": {
    gridTemplateColumns: "1fr",
  },
}));
